<template>
  <div style="position: relative;">
    <input
      class="input-time-mobile"
      ref="inputTime"
      type="time"
      :value="currentValue"
      :disabled="disabled"
      @change="onChangeDate"
    >
  </div>
</template>

<script>
import dateFns from 'date-fns';
import { setTimeOnDate } from '../utils/date-helper';

export default {
  name: 'InputTimeMobile',
  props: {
    value: {},
    disabled: {
      type: Boolean,
    },
    date: {
      default: null,
    },
    minimumDate: {
      type: Date,
      default: null,
    },
    maximumDate: {
      type: Date,
      default: null,
    },
    minimumDateWarningMessage: {
      type: String,
      default: '이전 시각 선택할 수 없습니다.',
    },
    maximumDateWarningMessage: {
      type: String,
      default: '이후 시각은 선택할 수 없습니다.',
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.currentValue = newValue;
        if(this.$refs['inputTime']) {
          this.$refs['inputTime'].value = newValue;
        }
      },
    },
  },
  data() {
    return {
      currentValue: null,
    };
  },
  methods: {
    onChangeDate(event) {
      let newValue = event.target.value;
      let newDatetime = setTimeOnDate(this.date, newValue);

      if(this.minimumDate && dateFns.isAfter(this.minimumDate, newDatetime)) {
        this.$message.warning(this.minimumDateWarningMessage);
        return event.target.value = this.currentValue;
      }

      if(this.maximumDate && dateFns.isBefore(this.maximumDate, newDatetime)) {
        this.$message.warning(this.maximumDateWarningMessage);
        return event.target.value = this.currentValue;
      }

      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
  },
};
</script>

<style lang="scss">
  .input-time-mobile {
    margin: 0;
    width: 100%;
    -webkit-appearance: none;
    height: 50px;
    line-height: 15px;
    font-size: 15px;
    letter-spacing: -0.8px;
    color: #4a4a4a;
    font-weight: 400;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #D3D3D3;
    padding-left: 15px;
    box-sizing: border-box;
  }
</style>